import { render } from "./Tenant.vue?vue&type=template&id=498b5727"
import script from "./Tenant.vue?vue&type=script&lang=js"
export * from "./Tenant.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/admin.23paskal.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__